import { render, staticRenderFns } from "./MyBoards.vue?vue&type=template&id=a7a18504&scoped=true&"
import script from "./MyBoards.vue?vue&type=script&lang=ts&"
export * from "./MyBoards.vue?vue&type=script&lang=ts&"
import style0 from "./MyBoards.vue?vue&type=style&index=0&id=a7a18504&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a18504",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
